import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import _ from 'lodash'

import LayerBox from '../../molecules/LayerBox'
import Map from '../../molecules/Map'
import SearchCity from '../../molecules/SearchCity'
import SearchLayer from '../../molecules/SearchLayer'
import SideCollapse from '../../atoms/SideCollapse'

const Container = styled.div`
  height: calc(100% - 60px);
  position: relative;
  overflow-x: hidden;
  z-index: 300;
`

class MapWithSelectors extends Component {
  constructor (props) {
    super(props)

    this.state = {
      clickCoordinates: {},
      selectedLayers: [],
      toggleComponents: {},
      activeCityId: null
    }

    this.onClickMap = this.onClickMap.bind(this)
    this.onClosePopOver = this.onClosePopOver.bind(this)
    this.onToggleAddLayerBtn = this.onToggleAddLayerBtn.bind(this)
    this.onCitySelect = this.onCitySelect.bind(this)
  }

  async onClickMap (el) {
    this.setState({
      clickCoordinates: el.latlng
    })
  }

  onClosePopOver () {
    this.setState({
      clickCoordinates: {}
    })
  }

  onToggleAddLayerBtn () {
    const { toggleComponents } = this.state
    const { addLayer } = toggleComponents

    const nToggleComponents = Object.assign({}, toggleComponents, { addLayer: !addLayer })

    this.setState({
      toggleComponents: nToggleComponents
    })
  }

  onCitySelect (cityId) {
    this.setState({ activeCityId: cityId });
  }

  render () {
    const { citiesLayer, layerActions, layers } = this.props
    const { clickCoordinates, toggleComponents } = this.state
    const selectedLayerId = layers.layers.length > 0 ? layers.layers[0].id : null

    const citiesOptions = _.map(citiesLayer, (city) => {
      return { value: city.id, label: city.nome, key: _.kebabCase(city.nome) };
    });

    if (layers.data === null) { return null; }

    return (
      <Container>
        <SideCollapse show width={16}>
          <LayerBox
            layerActions={layerActions}
            layers={layers}
            onClickAddLayer={this.onToggleAddLayerBtn}
          />
        </SideCollapse>
        {toggleComponents.addLayer &&
          <SearchLayer
            show={toggleComponents.addLayer}
            layers={layers}
            addLayers={layerActions.addLayers}
            onToggleModal={this.onToggleAddLayerBtn}
          />
        }
        <Map
          onClick={this.onClickMap}
          layers={layers}
          activeCityId={this.state.activeCityId}
          popupCoordinates={clickCoordinates}
          onPopupClose={this.onClosePopOver}
          selectedLayerId={selectedLayerId}
        />
        <SearchCity
          cities={ citiesOptions }
          onSelect={ this.onCitySelect }
        />
      </Container>
    )
  }
}

MapWithSelectors.propTypes = {
  layerActions: PropTypes.object.isRequired,
  layers: PropTypes.object.isRequired
}

export default MapWithSelectors



// WEBPACK FOOTER //
// ./src/components/organisms/MapWithSelectors/MapWithSelectors.js